module.exports = __webpack_public_path__ + "static/media/rel_programas_coachee.5fc857eb.svg";